import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SourcesPage } from "@/features/sources/SourcesPage";
import { sourcesQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";

const search = projectSearch.extend({
  status: z.enum(["all", "fresh", "stale", "error", "snoozed"]).optional(),
});

export const Route = createFileRoute("/w/$workspace/p/$project/sources")({
  validateSearch: search,
  loaderDeps: ({ search: s }) => ({ env: s.env ?? DEFAULT_ENV }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(sourcesQuery(params.workspace, params.project, deps.env)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const s = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <SourcesPage
        workspace={workspace}
        project={project}
        env={s.env ?? DEFAULT_ENV}
        status={s.status ?? "all"}
        onStatus={(status) =>
          navigate({
            search: (prev) => ({ env: prev.env, status: status === "all" ? undefined : status }),
            replace: true,
          })
        }
      />
    );
  },
});
